import { useLocation } from "react-router";

export function usePathnameParts() {
  const { pathname } = useLocation();
  return pathname.split("/").filter(Boolean); // /episodes/123 -> ["", "episodes", "123"], empty first value (due to leading slash) filtered out
}